import useMediaQuery from '@mui/material/useMediaQuery'

/**
 * Which shell the app is wearing: expanded (persistent side navigation) or compact
 * (bottom tab bar, single column).
 *
 * Layout decisions belong to the viewport, never to the user agent. This replaced a mix
 * of `breakpoints.down('sm')`, `breakpoints.down('md')` and `react-device-detect` that
 * disagreed with each other, so the same window could be "mobile" to one component and
 * "desktop" to its neighbour.
 *
 * @returns {boolean} True when the expanded shell is active.
 */
export default function useIsExpanded() {
  return useMediaQuery((theme) => theme.breakpoints.up('md'), { noSsr: true })
}
